/// Button
// Props:
// tags - (blue, link, linkActive) - set button tags
// href - creates a link button
// other props are passed to button

import classes from './Button.module.scss';
import { Link } from "react-router-dom";
export default function Button(props) {
    let style = {}
    if (props.style) {
        style = { ...style, ...props.style };
    }
    let classnames = classes.Button;
    if (props.tags) {
        classnames = classnames + " " + props.tags.map((tag) => {
            switch (tag) {
                case "blue":
                    return classes.TagBlue;
                case "link":
                    return classes.TagLink;
                case "linkActive":
                    return classes.TagLinkActive;
                default:
                    return classes.Button;
            }
        }).join(" ");
    }
    if (props.className) {
        classnames = classnames + " " + props.className;
    }

    let childrenElements = props.children;
    if (props.href) {
        childrenElements = (
            <Link to={props.href}>
                {props.children}
            </Link>
        )
    }
    if (props.forcehref) {
        childrenElements = (
            <a href={props.forcehref}>
                {props.children}
            </a>
        )
    }

    return (
        <button {...props} className={classnames} style={style}>
            {childrenElements}
        </button>
    )
}